module.exports = __webpack_public_path__ + "assets/img/27.1d64ac41.png";